// U7's learnerEmailsFull switch as the pages see it (infrastructure-
// specification, Feature switch). Read once when the app starts; off until
// read and off if it cannot be read, so "Add to calendar" never shows a
// download the API would refuse.
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { useApi } from '../app/api-context';

const LearnerEmailsSwitchContext = createContext(false);

export function LearnerEmailsSwitchProvider(props: { children: ReactNode }) {
  const api = useApi();
  const [isOn, setIsOn] = useState(false);
  useEffect(() => {
    let isCurrent = true;
    api
      .get<{ learnerEmailsFull?: unknown }>('/api/v1/public/features')
      .then((features) => {
        if (isCurrent) setIsOn(features.learnerEmailsFull === true);
      })
      // Unreadable switches keep the button hidden; nothing started fails.
      .catch(() => undefined);
    return () => {
      isCurrent = false;
    };
  }, [api]);
  return (
    <LearnerEmailsSwitchContext.Provider value={isOn}>
      {props.children}
    </LearnerEmailsSwitchContext.Provider>
  );
}

// A fixed switch, for tests and previews.
export function FixedLearnerEmailsSwitch(props: { isOn: boolean; children: ReactNode }) {
  return (
    <LearnerEmailsSwitchContext.Provider value={props.isOn}>
      {props.children}
    </LearnerEmailsSwitchContext.Provider>
  );
}

export const useIsLearnerEmailsOn = () => useContext(LearnerEmailsSwitchContext);
